export enum InsuranceType {
    Internal = 'Internal',
    Client = 'Client',
}